var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-content"},[_c('div',{staticClass:"location"},[_vm._v("达人管理中心 / 我的余额")]),_c('div',{staticClass:"white-bg shadow margin-top-20 padding30 radius"},[_c('detailed')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }